import { useDateFormatter } from 'shared/hooks/dates.hooks';
import { isToday } from 'shared/utils/date.utils';

const FORMAT_MAP = {
  longDate: 'formatLongDate',
  longDateTime: 'formatLongDateTime',
  shortDate: 'formatShortDate',
  shortDateTime: 'formatShortDateTime',
  shortTime: 'formatShortTime',
};

/**
 * AG Grid cell renderer that formats date values using the organization locale.
 *
 * @param {import('ag-grid-community').ICellRendererParams & {
 *   format?: 'longDate' | 'longDateTime' | 'shortDate' | 'shortDateTime' | 'shortTime' | 'smartDateTime',
 *   fallback?: string
 * }} params
 */
export function DateCell({ value, format = 'longDate', fallback = '-' }) {
  const formatters = useDateFormatter();

  if (!value) return fallback;

  if (format === 'smartDateTime') {
    return isToday(value)
      ? formatters.formatShortTime(value)
      : formatters.formatShortDateTime(value);
  }

  const formatterFn = formatters[FORMAT_MAP[format]];
  return formatterFn ? formatterFn(value) : value;
}
